export const TOGGLE_VIDEO = 'TOGGLE_VIDEO'

export function toggleVideoById (id: string) {
  return {
    type: TOGGLE_VIDEO,
    id
  }
}



// WEBPACK FOOTER //
// ./src/shared/actions/video.js